import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User} from 'src/app/Model/User/user.model';
import { Location } from '@angular/common';

@Component({
  selector: 'app-have-appointment-question',
  templateUrl: './have-appointment-question.component.html',
  styleUrls: ['./have-appointment-question.component.css']
})
export class HaveAppointmentQuestionComponent implements OnInit {
  currentUser:User;
  loggedInUserBranch;
  loggedInUserFullname;
  loggedInUsername;
  loggedInUserId;
  constructor(private router: Router,
    private _location: Location,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService) { 
          
    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if(this.currentUser){
      this.loggedInUsername=this.currentUser.userName;
    this.loggedInUserFullname=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
    this.loggedInUserBranch=this.currentUser.branch;
    this.loggedInUserId=this.currentUser.userName;

    }}

  ngOnInit(): void {

  }

  yesAppointmentQuestionaire(){
    if(this.currentUser){
      this.router.navigate(['../device-appointment-search',],{relativeTo:this.actroute});
    }else{
      this.router.navigate(['../appointment-search',],{relativeTo:this.actroute});
    }
  }

  noAppointmentQuestionaire(){
    if(this.currentUser){
      this.router.navigate(['../device-appointment-questionaire',],{relativeTo:this.actroute});
    }else{
      this.router.navigate(['../appointment-questionaire',],{relativeTo:this.actroute});
    }
  }
}
